module.exports = __webpack_public_path__ + "static/media/logo2.246a1606.jpg";